<script setup lang="ts">
defineProps<{
  actions?: {
    color?: string
    event: string
    flavor?: string
    label: string
  }[]
}>()

const emit = defineEmits<{
  (event: 'dialog-close'): void
  (event: string): void
}>()
const onEmit = (event: string) => {
  emit(event)
  emit('dialog-close')
}
</script>

<template>
  <div class="p-4 md:p-6">
    <div class="flex gap-4">
      <BaseButton
        :color="item?.color || undefined"
        :flavor="item?.flavor || undefined"
        :key="item.label"
        @click="onEmit(item.event)"
        v-for="item in actions"
        >{{ item.label }}</BaseButton
      >
    </div>
  </div>
</template>
